import PasswordForm from "./PasswordForm.container";

export default PasswordForm;
